var Handlebars = require("/home/travis/build/thelounge/lounge/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div data-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-target=\"#chan-"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-title=\""
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "\" class=\"chan "
    + alias2(alias1((depth0 != null ? depth0.type : depth0), depth0))
    + " chan-"
    + alias2(__default(require("/home/travis/build/thelounge/lounge/client/js/libs/handlebars/slugify.js")).call(alias3,(depth0 != null ? depth0.name : depth0),{"name":"slugify","hash":{},"data":data}))
    + "\">\n	<span class=\"badge"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.highlight : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.unread : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</span>\n	<button class=\"close\" aria-label=\"Close\"></button>\n	<span class=\"name\" title=\""
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "</span>\n</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return " highlight";
},"4":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(__default(require("/home/travis/build/thelounge/lounge/client/js/libs/handlebars/roundBadgeNumber.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.unread : depth0),{"name":"roundBadgeNumber","hash":{},"data":data}));
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.channels : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./client/views/chan.tpl
// module id = 152
// module chunks = 0